export default {
  ageLimit: 18
};
